import { useEffect, useState } from "react";
import api, { fmtCurrency } from "../lib/api";
import { toast } from "sonner";
import { Button } from "../components/ui/button";
import { Input } from "../components/ui/input";
import { Label } from "../components/ui/label";
import { Dialog, DialogContent, DialogHeader, DialogTitle, DialogTrigger } from "../components/ui/dialog";
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from "../components/ui/select";
import { Plus, Landmark, Trash2 } from "lucide-react";

export default function Accounts() {
  const [rows, setRows] = useState([]);
  const [open, setOpen] = useState(false);
  const [form, setForm] = useState(empty());
  function empty() { return { name: "", bank_name: "", account_number: "", currency: "TRY", opening_balance: 0, color: "#06B6D4" }; }
  const load = () => api.get("/accounts").then((r) => setRows(r.data));
  useEffect(() => { load(); }, []);

  const save = async () => {
    try {
      await api.post("/accounts", { ...form, opening_balance: parseFloat(form.opening_balance) });
      toast.success("Hesap eklendi"); setOpen(false); setForm(empty()); load();
    } catch (e) { toast.error(e?.response?.data?.detail || "Hata"); }
  };
  const del = async (id) => {
    if (!window.confirm("Silinsin mi?")) return;
    await api.delete(`/accounts/${id}`); toast.success("Silindi"); load();
  };

  return (
    <div className="space-y-5 nf-fade-up">
      <div className="flex flex-wrap items-center justify-between gap-3">
        <div>
          <div className="text-xs uppercase tracking-widest font-mono-num text-slate-500">BANKA & KASA</div>
          <h1 className="font-head text-3xl font-extrabold tracking-tight">Hesaplar</h1>
        </div>
        <Dialog open={open} onOpenChange={setOpen}>
          <DialogTrigger asChild><Button data-testid="add-account-btn" className="bg-gradient-to-r from-cyan-500 to-emerald-500 text-slate-950 font-semibold"><Plus className="w-4 h-4 mr-1.5" /> Yeni Hesap</Button></DialogTrigger>
          <DialogContent className="bg-[#121722] border-slate-800">
            <DialogHeader><DialogTitle className="font-head">Yeni Hesap</DialogTitle></DialogHeader>
            <div className="space-y-3">
              <div><Label>Hesap Adı</Label><Input value={form.name} onChange={(e) => setForm({ ...form, name: e.target.value })} className="bg-slate-900/60 border-slate-800 mt-1" /></div>
              <div><Label>Banka Adı</Label><Input value={form.bank_name} onChange={(e) => setForm({ ...form, bank_name: e.target.value })} className="bg-slate-900/60 border-slate-800 mt-1" /></div>
              <div className="grid grid-cols-2 gap-3">
                <div><Label>Döviz</Label>
                  <Select value={form.currency} onValueChange={(v) => setForm({ ...form, currency: v })}>
                    <SelectTrigger className="bg-slate-900/60 border-slate-800 mt-1"><SelectValue /></SelectTrigger>
                    <SelectContent>{["TRY", "USD", "EUR"].map((c) => <SelectItem key={c} value={c}>{c}</SelectItem>)}</SelectContent>
                  </Select>
                </div>
                <div><Label>Açılış Bakiye</Label><Input type="number" value={form.opening_balance} onChange={(e) => setForm({ ...form, opening_balance: e.target.value })} className="bg-slate-900/60 border-slate-800 mt-1" /></div>
              </div>
              <Button onClick={save} className="w-full bg-gradient-to-r from-cyan-500 to-emerald-500 text-slate-950 font-semibold">Kaydet</Button>
            </div>
          </DialogContent>
        </Dialog>
      </div>

      <div className="grid sm:grid-cols-2 lg:grid-cols-3 gap-4">
        {rows.map((a) => (
          <div key={a.id} className="nf-card p-5 relative overflow-hidden group">
            <div className="absolute -top-10 -right-10 w-32 h-32 rounded-full opacity-20" style={{ background: a.color }} />
            <div className="flex items-start justify-between relative">
              <div className="w-10 h-10 rounded-xl flex items-center justify-center" style={{ background: `${a.color}20`, color: a.color }}>
                <Landmark className="w-5 h-5" />
              </div>
              <button data-testid={`delete-account-${a.id}`} onClick={() => del(a.id)} className="opacity-0 group-hover:opacity-100 text-slate-500 hover:text-rose-400 p-1 transition"><Trash2 className="w-3.5 h-3.5" /></button>
            </div>
            <div className="mt-3 relative">
              <div className="font-head font-bold text-lg">{a.name}</div>
              <div className="text-xs text-slate-500 font-mono-num uppercase tracking-widest mt-0.5">{a.bank_name} • {a.currency}</div>
              <div className="mt-5 font-head font-extrabold text-3xl font-mono-num" style={{ color: a.balance >= 0 ? "#F8FAFC" : "#F43F5E" }}>
                {fmtCurrency(a.balance, a.currency)}
              </div>
              <div className="text-[10px] uppercase tracking-widest font-mono-num text-slate-500 mt-1">güncel bakiye</div>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
}
